/**
 * ToolResultView — 两层展示容器（视图切换模式）
 *
 * 默认显示 transformer 生成的结构化摘要。
 * 点击「查看原始数据」切换到原始文本视图（替换摘要），再点切回。
 */

import { memo, useMemo, useState } from 'react'
import { Code, LayoutList } from 'lucide-react'
import { getToolResultTransformer } from '../registry'
import './tool-result-view.less'

/* ── 主组件 ── */

export const ToolResultView = memo(function ToolResultView({
  rawResult,
  toolLabel,
}: {
  rawResult: string
  toolLabel: string
}) {
  const [showRaw, setShowRaw] = useState(false)

  const { summary, raw } = useMemo(
    () => getToolResultTransformer(toolLabel)(rawResult, toolLabel),
    [rawResult, toolLabel],
  )

  const hasRaw = raw.trim().length > 0

  return (
    <div className="tool-result">
      {hasRaw && (
        <button
          className="tool-result__toggle"
          onClick={() => setShowRaw(!showRaw)}
          type="button"
        >
          {showRaw ? (
            <>
              <LayoutList className="h-2.5 w-2.5" />
              <span>查看摘要</span>
            </>
          ) : (
            <>
              <Code className="h-2.5 w-2.5" />
              <span>查看原始数据</span>
            </>
          )}
        </button>
      )}

      {showRaw ? (
        <pre className="tool-result__raw">{raw}</pre>
      ) : (
        <div className="tool-result__summary">{summary}</div>
      )}
    </div>
  )
})
